export const ApiParams = {
  // IDs
  USER_ID: 'userId',
  USER_HISTORY_ID: 'userHistoryId',
  TOKEN_VAULT_ID: 'tokenVaultId',
  EMAIL_ID: 'emailId',
  SMS_ID: 'smsId',
  FILE_ID: 'fileId',
  USER_SESSION_ID: 'userSessionId',
  USER_REGISTRATION_ID: 'userRegistrationId',
  SUBSCRIPTION_ID: 'subscriptionId',
  TRANSACTION_ID: 'transactionId',
  PLAN_ID: 'planId',
  TICKET_ID: 'ticketId',
  NOTIFICATION_ID: 'notificationId',
  BETA_REGISTRATION_ID: 'betaRegistrationId',

  // Route Params
  TOKEN: 'token',
  TYPE: 'type',
} as const;
